// Coin/credit presets for common software project tasks.
// icon = a key into lib/icons.js ICON_MAP (lucide component).
export const PRESETS = [
  { id: "frontend", name: "Frontend UI", category: "Frontend", defaultCoins: 40, icon: "Smartphone", color: "#4A7A59" },
  { id: "backend", name: "Backend API", category: "Backend", defaultCoins: 50, icon: "Server", color: "#3B82F6" },
  { id: "database", name: "Database", category: "Database", defaultCoins: 25, icon: "Database", color: "#F59E0B" },
  { id: "integration", name: "Integration", category: "Integration", defaultCoins: 60, icon: "Network", color: "#8B5CF6" },
  { id: "ai", name: "AI / LLM Feature", category: "AI", defaultCoins: 70, icon: "Sparkles", color: "#A855F7" },
  { id: "design", name: "Design", category: "Design", defaultCoins: 35, icon: "Palette", color: "#EC4899" },
  { id: "testing", name: "Testing", category: "Testing", defaultCoins: 30, icon: "CheckCheck", color: "#22C55E" },
  { id: "bugfix", name: "Bug Fix", category: "Bug Fix", defaultCoins: 20, icon: "Bug", color: "#EF4444" },
];

export const CUSTOM_META = {
  category: "Custom",
  icon: "Tag",
  color: "#8E8E93",
};

// Quick-pick coin values for manual entry.
export const COIN_PRESETS = [10, 25, 50, 100, 250, 500];

// Emergent credit purchase packs (coins + real dollar price).
export const PURCHASE_TIERS = [
  { id: "p100", label: "100 credits", coins: 100, dollars: 20 },
  { id: "p250", label: "250 credits", coins: 250, dollars: 50 },
  { id: "p500", label: "500 credits", coins: 500, dollars: 100 },
  { id: "p1250", label: "1,250 credits", coins: 1250, dollars: 250 },
  { id: "p3000", label: "3,000 credits", coins: 3000, dollars: 500, badge: "20% More" },
  { id: "p6000", label: "6,000 credits", coins: 6000, dollars: 1000, badge: "20% More" },
];
